import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { clearSwiperList } from '../store/contributions/contributionsSlice'

export const useClearSwiperList = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        return () => {
            dispatch(clearSwiperList())
        }
    }, [])
}
